const paragraph = ({img, text}) => {
	return (
		<div className='paragraph'>
			{img}
			<p className='paragraphText' >{text}</p>
		</div>
	)
}

export default paragraph